/*
 * Winy Mind Pvt. Ltd.
 * Created by suraj on 20/10/23, 3:51 pm
 * Copyright (c) 2023 . All rights reserved.
 * Last modified 20/10/23, 3:51 pm
 */

package tta.destinigo.talktoastro.feature_chat_consultation_new.data.response.concern_question

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable


@Serializable
data class ConcernQuestions(
    @SerialName("category") val category: String, // Fitness Experts
    @SerialName("character_length") val characterLength: Int?, // null
    @SerialName("created_at") val createdAt: String, // 2023-10-20 11:34:48
    @SerialName("id") val id: String, // 1
    @SerialName("input_type") val inputType: String, // null
    @SerialName("questions") val questions: String, // Test
    @SerialName("required") val required: Int, // 1
    @SerialName("updated_at") val updatedAt: String // 2023-10-20 11:34:48
)